module.exports = __webpack_public_path__ + "img/audio_play.79323212.gif";